import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { serviceData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    position: 'relative',
    height: '200px',
    marginTop: 80,
    width: '100%',
    background: '#f27474',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0.9,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  centerTitle: {
    width: 400,
    height: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    marginTop: '10px',
    padding: '0px 10px',
    '& h1': {
      fontSize: '40px',
      color: 'white',
      fontWeight: 500,
      lineHeight: '28px',
      letterSpacing: '1px',
      fontFamily: 'Open Sans, sans-serif',
      textAlign: 'center'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  wraper: {
    // backgroundColor: 'red',
    display: 'flex',
    justifyContent: 'center',
    padding: '100px 0px'
  },
  contact: {
    // backgroundColor: 'pink',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  gridItem: {
    // backgroundColor: 'red',
    padding: '0px 10px',
    '@media (max-width:900px)': {
      marginBottom: 15,
      marginTop: 15,
      display: 'flex',
      justifyContent: 'center'
    }
  },
  contactInfo: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    marginTop: 30,
    '&:hover': {
      '& $description, $iconCard': {
        color: '#F78181'
      }
    }
  },
  title: {
    fontSize: '30px',
    fontFamily: 'Oregano, cursive',
    color: '#4c494a',
    fontWeight: 400
  },
  description: {
    fontSize: '18px',
    fontFamily: 'Oregano, cursive',
    color: 'grey'
  },
  iconCard: {
    fontSize: '18px',
    marginRight: 15,
    fontFamily: 'Oregano, cursive',
    color: 'grey'
  },
  cardIllustration: {
    height: '100%',
    width: '100%',
    backgroundColor: 'white'
  },
  imgIllustration: {
    height: '100%',
    width: '100%',
    objectFit: 'contain'
  },
  butterflyContainer: {
    height: 100,
    width: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
    '& h3': {
      zIndex: 2,
      fontSize: '15px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Oregano, cursive'
    }
  },
  butterflyImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    zIndex: 1
  },
  buttonShowmore: {
    color: '#F78181',
    position: 'relative',
    cursor: 'pointer',
    width: 65,
    marginTop: 20,
    transform: 'rotate(-7deg)',
    fontFamily: 'Oregano, cursive',
    '& a': {
      color: '#F78181',
      cursor: 'pointer',
      textDecoration: 'none'
    },
    '&:after': {
      position: 'absolute',
      content: '""',
      display: 'block',
      left: 0,
      top: 25,
      bottom: 0,
      width: '100%',
      height: '1px',
      background: '#F78181'
    },
    '&:hover': {
      animation: '$all 1s forwards'
    }
  },
  textIllustration: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#555',
    lineHeight: '24pt',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  TitleSection: {
    fontFamily: 'Oregano, cursive',
    fontSize: '48px',
    fontWeight: 400,
    color: '#F78181',
    marginBottom: 20,
    '@media (max-width:1024px)': {
      fontSize: '35px',
      marginBottom: 20
    }
  }
}));

const Services = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <Box className={classes.centerTitle}>
            <h1>{t('nos_services')}</h1>
          </Box>
        </Box>
      </Grid>
      <Grid container xs={12} className={classes.wraper}>
        <Container style={{ overflow: 'hidden' }} maxWidth="lg">
          {serviceData.map((row) => (
            <Grid container xs={12} className={classes.contact}>
              <Grid
                item
                xs={12}
                md={6}
                className={classes.gridItem}
                style={{ paddingLeft: 50 }}
                order={{ md: row.id % 2 === 0 ? 1 : 2, xs: 2 }}
              >
                <Box>
                  <Typography
                    className={classes.TitleSection}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    {t(row.title)}
                  </Typography>
                  <Typography
                    className={classes.textIllustration}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    {t(row.text)}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                className={classes.gridItem}
                order={{ md: row.id % 2 === 0 ? 2 : 1, xs: 1 }}
              >
                <Box className={classes.cardIllustration}>
                  <img
                    alt="img"
                    src={row.imgUrl}
                    className={classes.imgIllustration}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  />
                </Box>
              </Grid>
            </Grid>
          ))}
        </Container>
      </Grid>
    </div>
  );
};

export default Services;
